import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo/romas.png'


const _hoisted_1 = {
  class: "container-fluid",
  style: {}
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xl-12 p-0" }
const _hoisted_4 = { class: "login-card login-dark" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = { class: "login-main" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-input position-relative" }
const _hoisted_10 = ["aria-label"]
const _hoisted_11 = { class: "form-group mb-0" }
const _hoisted_12 = { class: "text-end mt-3" }
const _hoisted_13 = {
  ref: "submitButton",
  class: "btn btn-primary btn-block py-3 w-100",
  type: "submit"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_center = _resolveComponent("center")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createElementVNode("div", null, [
              _createElementVNode("a", _hoisted_5, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => _cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      class: "img-fluid for-light",
                      src: _imports_0,
                      alt: "looginpage",
                      style: {"max-width":"350px"}
                    }, null, -1),
                    _createElementVNode("img", {
                      class: "img-fluid for-dark",
                      src: _imports_0,
                      alt: "looginpage"
                    }, null, -1)
                  ])),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Form, {
                class: "theme-form",
                ref: "loginForm",
                onSubmit: _ctx.onSubmitLogin,
                "validation-schema": _ctx.loginSchema
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_center, null, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                      _createElementVNode("h4", null, "Connectez-vous à votre compte", -1),
                      _createElementVNode("p", null, "Entrez votre email et votre mot de passe", -1)
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("label", { class: "col-form-label" }, "Email ", -1)),
                    _createVNode(_component_Field, {
                      name: "email",
                      type: "email",
                      class: "form-control",
                      placeholder: "Entrer votre email"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "email",
                      class: "text-danger"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "col-form-label" }, "Mot de passe", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_Field, {
                        name: "password",
                        type: _ctx.showPassword ? 'password' : 'text',
                        class: "form-control pr-5",
                        placeholder: "Entrer votre mot de passe"
                      }, null, 8, ["type"]),
                      _createElementVNode("i", {
                        class: _normalizeClass([{ 'fa fa-eye': !_ctx.showPassword, 'fa fa-eye-slash': _ctx.showPassword }, "flaticon-eye position-absolute end-0 top-50 translate-middle-y pe-2"]),
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleShow && _ctx.toggleShow(...args))),
                        "aria-label": _ctx.buttonLabel
                      }, null, 10, _hoisted_10),
                      _createVNode(_component_ErrorMessage, {
                        name: "password",
                        class: "text-danger"
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("button", _hoisted_13, "Connectez-vous maintenant ", 512)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit", "validation-schema"])
            ])
          ])
        ])
      ])
    ])
  ]))
}